import axios from 'axios';
import { request, responseError } from './Api.interceptor';

class ApiService {
  constructor(route) {
    this.resource = axios.create({
      baseURL: process.env.address.api
    })
    this.resource.interceptors.request.use(request);
    this.resource.interceptors.response.use(resp => resp, responseError);
    this.route = route
  }
  all() {
    return this.resource.get(this.route)
  }
  getById(id) {
    return this.resource.get(`${this.route}/${id}`)
  }
  save(model) {
    return this.resource.post(this.route, model)
  }
  update(id, model) {
    return this.resource.put(`${this.route}/${id}`, model)
  }
  delete(id) {
    return this.resource.delete(`${this.route}/${id}`)
  }
}

export default ApiService



// WEBPACK FOOTER //
// ./src/services/axios/Api.service.js